<template>
	<div>
		<q-modal
			v-model="show_report"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-list separator highlight link>
						<q-item
							v-for="(question, index) in questions"
							:key="index"
							@click.native="showQuestion(question)"
							:class="{ 'text-grey-6': isQuestionAnswersBlocked(question) }"
						>
							<q-item-main
								class="column"
							>
								<q-item-tile label>{{ question.title }}</q-item-tile>
								<q-item-tile sublabel>{{ question.qty_user_answered }} {{ question.qty_user_answered === 1 ? $t('user_answer') : $t('user_answers') }}</q-item-tile>
								<q-item-tile sublabel class="q-mt-sm">
									Alternativas
								</q-item-tile>
								<q-item-tile>
									<q-list no-border no-padding>
										<q-item v-for="(alternative, ai) in question.percentual_answers.alternatives" :key="ai" class="q-pa-none q-caption text-faded " style="min-height: 20px; height: 20px;">
											{{ alternative.title }}: {{ alternative.percentage }}% - total {{  alternative.count }}
										</q-item>
									</q-list>
								</q-item-tile>
							</q-item-main>

							<q-tooltip v-if="isQuestionAnswersBlocked(question)">
								{{ $t('anonymous_survey_report_tooltip') }}
							</q-tooltip>
						</q-item>
					</q-list>
				</div>
			</q-modal-layout>
		</q-modal>

		<user-answers
			:question="question"
			:show_question="show_question"
			:title="title"
			:id="id"
			@hide_user_answers="hideUserAnswers"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAnswers from 'components/admin/surveys/UserAnswers'

export default {
	props: ['show_report_survey', 'id', 'status', 'title', 'is_anonymous'],

	components: {
		'user-answers': UserAnswers,
	},

	data() {
		return {
			questions: [],
			question: {},
			show_question: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		show_report: {
			get() {
				return this.show_report_survey
			},
			set() {
				this.questions = []
				this.$emit('hide_report', '')
			},
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_surveys/surveys/${this.id}/survey_report_questions/`, this.getHeader)
				.then((response) => {
					this.questions = response.data
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showQuestion(question) {
			if (question.qty_user_answered > 0 && !this.isQuestionAnswersBlocked(question)) {
				this.question = question
				this.show_question = true
			}
		},

		isQuestionAnswersBlocked(question) {
			return this.is_anonymous && this.status == 1 && question.qty_user_answered > 0
		},

		hideUserAnswers() {
			this.show_question = false
			this.question = {}
		},
	},

	watch: {
		show_report: function() {
			if (this.show_report) {
				this.fetchData()
			}
		},
	},
}
</script>

<style></style>
